module.exports = __webpack_public_path__ + "img/mm-success@2x.226ba0ee.png";